<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="items"
      :item-key="itemKey"
      disable-pagination
      hide-default-footer
      
      mobile-breakpoint="0"
      dense
      :group-by="groupBy"
    >
      <template v-slot:[`item.completed`]="{ item }">
        <v-switch  v-if="mode === 'boolean'"
          inset
          dense
          :input-value="item.completed"
          @change="toggle($event, item)"
        ></v-switch>
        <v-row class="align-center" v-if="mode === 'integer'">
          <v-btn
            style="
              width: 24px;
              height: 24px;
              min-height: 24px;
              min-width: 24px;
              padding: 8px;
            "
            color="primary"
            @click="decrement(item)"
            :disabled="item.completed <= 0"
          >
            <v-icon x-small>mdi-minus</v-icon>
          </v-btn>
          <div style="padding: 5px">
            {{ item.completed || 0 }} / {{ item.total }}
          </div>
          <v-btn
            style="
              width: 24px;
              height: 24px;
              min-height: 24px;
              min-width: 24px;
              padding: 8px;
            "
            color="primary"
            @click="increment(item)"
            :disabled="item.completed >= item.total"
          >
            <v-icon x-small>mdi-plus</v-icon>
          </v-btn>
        </v-row>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: "GenericChecklist",
  props: ["headers", "items", "itemKey", "groupBy"],
  methods: {
    toggle: function ($event, item) {
      if ($event) {
        this.$emit("complete", item);
      } else {
        this.$emit("uncomplete", item);
      }
    },
    increment: function(item) {
        this.$emit("increment", item);
    },
    decrement: function(item) {
        this.$emit("decrement", item);
    }
  },
  computed: {
      mode: function() {
          if (this.items.length == 0) {
              return ''
          } else {
              if (Number.isInteger(this.items[0].completed)) {
                  return 'integer'
              } else {
                  return 'boolean'
              }
          }
      }
  }
};
</script>